import { render } from "./FiltersSearch.vue?vue&type=template&id=0b6292fe&ts=true"
import script from "./FiltersSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./FiltersSearch.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/FiltersSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b6292fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b6292fe', __exports__)) {
    api.reload('0b6292fe', __exports__)
  }
  
  module.hot.accept("./FiltersSearch.vue?vue&type=template&id=0b6292fe&ts=true", () => {
    api.rerender('0b6292fe', render)
  })

}


export default __exports__